/** @format */

import {useTranslation} from 'react-i18next';

import {providerNewIconSrc} from 'helpers/imageHelpers';

import {OauthProvider as Provider} from 'graphql/generated/types';

import {type AnalyticType} from 'types';

import {classes, CardHeaderRoot, IconsStrip, MediaplanBadge, ProjectName} from './styles';

interface Props {
  adSystems: Provider[];
  analytics: AnalyticType[];
  name: string;
  mediaplanType: 'MEDIA' | 'PERFORM' | null;
}

export function CardHeader({adSystems, analytics, name, mediaplanType}: Props) {
  const {t} = useTranslation();

  return (
    <CardHeaderRoot>
      <IconsStrip>
        {adSystems.map(provider => {
          const src = providerNewIconSrc(provider, 40);
          if (!src) return null;
          return (
            <img
              key={provider}
              className={classes.icon}
              src={src}
              alt={provider}
              width={22}
              height={22}
            />
          );
        })}
        {analytics.map(analytic => {
          const src = providerNewIconSrc(analytic as Provider, 40);
          if (!src) return null;
          return (
            <img
              key={analytic}
              className={classes.icon}
              src={src}
              alt={analytic}
              width={22}
              height={22}
            />
          );
        })}
      </IconsStrip>

      <ProjectName>{name}</ProjectName>

      {mediaplanType !== null && (
        <MediaplanBadge>{t(`mediaplan_type.${mediaplanType}`)}</MediaplanBadge>
      )}
    </CardHeaderRoot>
  );
}
